import { merge } from 'lodash';

/**
 * SkuMeta data as generated by lambda function.
 */
export class SkuMetadataModel {
  lastUpdateDate: string;
  size: number;
  active: number;
  inactive: number;
  properties: string[];
  currencies: string[];
  collections: string[];

  constructor(originalValue?: Partial<SkuMetadataModel>) {
    merge(this, originalValue);
  }
}

// Hack! It makes sure that in the test scripts & test are using the same
// reference to the class
export const SkuMetadataModelProvider = {
  provide: 'SkuMetadataModel',
  useValue: SkuMetadataModel,
};
